export enum DeclarationTypeEnum {
    ACTIVITY = 1,
    EXPENSE_REPORT = 2,
    ABSENCE = 3,
    INTERNAL_ACTIVITY = 4,
    ACADEMIC_TRAINING = 5,
}
